import { Breadcrumb, Flex } from 'antd';
import { AuditOutlined } from '@ant-design/icons';
import { Link, useParams } from 'react-router-dom';

export const ContractBreadcrumbs = () => {
  const params = useParams();
  const companyId = params.companyId;

  return (
    <Breadcrumb>
      <Breadcrumb.Item>
        <Flex gap={4} align="center">
          <AuditOutlined />
          Gestão de certificados
        </Flex>
      </Breadcrumb.Item>
      <Breadcrumb.Item>
        <Link to={`/certificate_management/companies`}>Unidades</Link>
      </Breadcrumb.Item>
      <Breadcrumb.Item>
        <Link to={`/certificate_management/companies/show/${companyId}?tab=contracts`}>
          Unidade
        </Link>
      </Breadcrumb.Item>
      <Breadcrumb.Item>Contrato</Breadcrumb.Item>
    </Breadcrumb>
  );
};
